/* ============================================================
   AURIFEXA — motion layer.
   Performance red lines (DESIGN.md v2): transform/opacity only,
   no blur filters, no backdrop-filter, hero-local canvas paused
   off-screen, no scroll hijacking. #static in the URL freezes
   everything (screenshots / low-end fallback).
   Every feature is guarded by element existence so sections can
   be added/removed freely in the theme editor.
   ============================================================ */
(function () {
  var STATIC = /static/i.test(location.search + location.hash);
  var reduced = STATIC || window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (STATIC) document.documentElement.className += ' static';

  /* ---------- molten casting stream (hero-local canvas) ---------- */
  var cv = document.getElementById('cast');
  var hero = document.querySelector('.hero');
  if (cv && hero) {
    var ctx = cv.getContext('2d');
    var W, H, DPR = Math.min(window.devicePixelRatio || 1, 1.5), sparks = [];
    var born = 0, mx = 0.5;
    var resize = function () {
      W = hero.clientWidth; H = hero.clientHeight;
      cv.width = W * DPR; cv.height = H * DPR;
      cv.style.width = W + 'px'; cv.style.height = H + 'px';
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      sparks = [];
      for (var i = 0; i < 34; i++) sparks.push(mkSpark(true));
    };
    var mkSpark = function (seed) {
      return { x: W * (0.18 + Math.random() * 0.64),
               y: seed ? H * (0.4 + Math.random() * 0.5) : H * (0.68 + Math.random() * 0.12),
               vy: 0.25 + Math.random() * 0.55, vx: (Math.random() - 0.5) * 0.22,
               r: 0.6 + Math.random() * 1.3, tw: Math.random() * 6.28, hot: Math.random() < 0.16 };
    };
    var draw = function (t) {
      if (!born) born = t;
      var pour = reduced ? 1 : Math.min(1, (t - born) / 2000);
      pour = pour * pour * (3 - 2 * pour);
      ctx.clearRect(0, 0, W, H);
      var g0 = ctx.createRadialGradient(W / 2, H * 0.72, 10, W / 2, H * 0.72, W * 0.55);
      g0.addColorStop(0, 'rgba(210,169,79,' + (0.10 * pour).toFixed(3) + ')');
      g0.addColorStop(0.5, 'rgba(196,81,31,' + (0.04 * pour).toFixed(3) + ')');
      g0.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g0; ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      var drift = (mx - 0.5) * 16;
      var xMax = -20 + (W + 40) * pour;
      for (var s = 0; s < 6; s++) {
        var yb = H * 0.66 + (s - 2.5) * 10 + drift * (0.4 + s * 0.1);
        var amp = 16 + s * 7, sp = 0.00030 + s * 0.00005, ph = s * 1.6;
        ctx.beginPath();
        for (var x = -20; x <= xMax; x += 16) {
          var env = Math.sin(Math.min(Math.max(x / W, 0), 1) * Math.PI);
          var y = yb + Math.sin(x * 0.0038 + t * sp + ph) * amp * env
                     + Math.sin(x * 0.0011 - t * sp * 0.6) * 8 * env;
          if (x === -20) ctx.moveTo(x, y); else ctx.lineTo(x, y);
        }
        var lg = ctx.createLinearGradient(0, 0, W, 0);
        lg.addColorStop(0, 'rgba(210,169,79,0)');
        lg.addColorStop(0.5, 'rgba(245,218,142,' + (0.34 - s * 0.045).toFixed(3) + ')');
        lg.addColorStop(1, 'rgba(210,169,79,0)');
        ctx.strokeStyle = lg; ctx.lineWidth = 1.7 - s * 0.16; ctx.stroke();
      }
      for (var i = 0; i < sparks.length; i++) {
        var p = sparks[i];
        p.y -= p.vy; p.x += p.vx; p.tw += 0.05;
        if (p.y < H * 0.18) sparks[i] = p = mkSpark(false);
        var a = (0.2 + 0.8 * Math.abs(Math.sin(p.tw))) * 0.55 * pour;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.2832);
        ctx.fillStyle = p.hot ? 'rgba(196,81,31,' + (a * 0.9).toFixed(3) + ')'
                              : 'rgba(232,196,120,' + a.toFixed(3) + ')';
        ctx.fill();
      }
      ctx.globalCompositeOperation = 'source-over';
    };
    var geomOk = function () {
      return W === hero.clientWidth && H === hero.clientHeight
        && cv.width === Math.round(W * DPR) && cv.height === Math.round(H * DPR);
    };
    var running = false, rafId = 0, wdog = 0;
    var loop = function (t) {
      if (++wdog > 120) { wdog = 0; if (!geomOk()) refresh(); }
      draw(t);
      if (running) rafId = requestAnimationFrame(loop);
    };
    /* resizing the canvas clears it — in frozen mode repaint the single frame */
    var refresh = function () { resize(); if (reduced) draw(2400); };
    refresh();
    window.addEventListener('resize', refresh);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(refresh);
    /* standby / canvas hibernation / display-scale changes fire no resize —
       rebuild on foreground return and on context restoration */
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { DPR = Math.min(window.devicePixelRatio || 1, 1.5); refresh(); }
    });
    cv.addEventListener('contextrestored', refresh);
    if ('ResizeObserver' in window) new ResizeObserver(function () {
      if (!geomOk()) refresh();
    }).observe(hero);
    if (!reduced) {
      new IntersectionObserver(function (en) {
        var vis = en[0].isIntersecting;
        if (vis && !running) { running = true; rafId = requestAnimationFrame(loop); }
        if (!vis && running) { running = false; cancelAnimationFrame(rafId); }
      }, { threshold: 0.01 }).observe(hero);
    }

    /* pointer only steers the canvas drift (mx). The old hero-inner
       parallax + scroll-scrubbed fade are gone for good: both park the
       text on a composited layer whose state can freeze after standby /
       tab switches — the unfixable "hero goes blurry/dim" bug. Solid
       text has no failure mode. */
    if (!reduced && matchMedia('(pointer:fine)').matches) {
      hero.addEventListener('pointermove', function (e) { mx = e.clientX / W; });
    }
  }

  /* ---------- entrance reveals: transform/opacity ONLY ---------- */
  if (!reduced && window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
    /* Hero entrance lives in CSS now (az-theme.css @keyframes heroIn):
       compositor-driven, wall-clock timed — it finishes even in throttled
       background tabs, where a GSAP/rAF intro freezes mid-flight. */
    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      gsap.fromTo(el, { opacity: 0, y: 36 },
        { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out',
          scrollTrigger: { trigger: el, start: 'top 88%' } });
    });
    document.querySelectorAll('.ehead').forEach(function (el) {
      gsap.fromTo(el, { '--grow': 0 }, { '--grow': 1, duration: 1.7, ease: 'power2.inOut',
        scrollTrigger: { trigger: el, start: 'top 90%' } });
    });
  }

  /* ---------- mobile drawer ---------- */
  var burger = document.querySelector('.burger');
  var drawer = document.querySelector('.drawer');
  if (burger && drawer) {
    var overlay = document.querySelector('.drawer-overlay');
    var closeDrawer = function () { document.body.classList.remove('drawer-open'); };
    burger.addEventListener('click', function () { document.body.classList.add('drawer-open'); });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('a, .drawer-close').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- scroll progress thread ---------- */
  var progEl = document.querySelector('.progress');
  if (progEl) {
    var progTick = false;
    window.addEventListener('scroll', function () {
      if (progTick) return; progTick = true;
      requestAnimationFrame(function () {
        var d = document.documentElement;
        var max = d.scrollHeight - d.clientHeight;
        progEl.style.transform = 'scaleX(' + (max > 0 ? d.scrollTop / max : 0) + ')';
        progTick = false;
      });
    }, { passive: true });
  }

  /* ---------- werkzeuge filter ---------- */
  var chips = document.querySelectorAll('.chip-f');
  var cards = document.querySelectorAll('.wk');
  var count = document.getElementById('count');
  if (chips.length && cards.length) {
    var applyFilter = function (f) {
      var n = 0;
      cards.forEach(function (c) {
        var show = f === 'alle'
          || (f === 'gratis' ? c.dataset.free === '1' : c.dataset.cat === f);
        c.classList.toggle('off', !show);
        if (show) n++;
      });
      if (count) count.textContent = n + (n === 1 ? ' Werkzeug' : ' Werkzeuge');
      if (window.ScrollTrigger) ScrollTrigger.refresh();
    };
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () {
        chips.forEach(function (o) { o.classList.remove('on'); });
        ch.classList.add('on');
        applyFilter(ch.dataset.f);
      });
    });
    document.querySelectorAll('[data-goto]').forEach(function (a) {
      a.addEventListener('click', function () {
        var f = a.dataset.goto;
        chips.forEach(function (o) { o.classList.toggle('on', o.dataset.f === f); });
        applyFilter(f);
      });
    });
  }

  /* ---------- card cursor-glow + gentle 3D tilt ---------- */
  if (!reduced && matchMedia('(pointer:fine)').matches) {
    document.querySelectorAll('.wk').forEach(function (c) {
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect();
        var x = e.clientX - r.left, y = e.clientY - r.top;
        c.style.setProperty('--mx', x + 'px');
        c.style.setProperty('--my', y + 'px');
        var rx = (y / r.height - 0.5) * -4.2, ry = (x / r.width - 0.5) * 4.2;
        c.style.transform = 'perspective(700px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-4px)';
      });
      c.addEventListener('mouseleave', function () { c.style.transform = ''; });
    });
    document.querySelectorAll('.plan').forEach(function (c) {
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect();
        c.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        c.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
    document.querySelectorAll('.btn, .play').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) / r.width * 7) + 'px,'
                                         + ((e.clientY - r.top - r.height / 2) / r.height * 5) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
  }
})();
